import React from 'react';
import { motion } from "framer-motion";
import useMediaQuery from '../hooks/useMediaQuery';
import LineGradient from '../components/LineGradient';

const Experience = () => {

    const isAboveLarge = useMediaQuery("(min-width: 1060px)");

    return (
        <section id="experience" className="pt-10 ">
            {/* HEADER AND IMAGE SECTION */}
            <div className="mt-12">
                <motion.div
                    // className="md:w-1/3"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    variants={{
                        hidden: { opacity: 0, x: -50 },
                        visible: { opacity: 1, x: 0 },
                    }}
                >
                    <p className="font-playfair font-semibold text-4xl mb-5">
                        <span className="text-cyan-500">EXPERIENCE</span>
                        <LineGradient width=" w-[150px] mt-3" />
                    </p>
                    <div className='grid grid-cols-1 lg:grid-cols-2 p-5 pb-0'>
                        <div className='border border-1 border-blue-200 p-5 '>

                        <div >
                         <p className="text-2xl mb-5">
                               FrontEnd Developer (React.js & Next.js)

                            </p>
                            <p className='text-lg'>
                                Downpour Consultancy Services Private Limited <br></br>
                                Apr 2023 - October 2023 (Internship & Probesion Period)<br></br>
                                Uttar Pradesh, India ( Remote)
                            </p>
                         </div>
                            {/* <ul className='mt-3'>
                            ● Analysis of requirements and implementation of them.
● Managing Front-End code and development in an efficient way.
● Develop Features following Figma.      </ul> */}
                        </div>
                        {/* 2 */}
                        <div className='border border-1 border-blue-200 p-5 '>

                            <p className="text-2xl mb-5">
                            FrontEnd Developer 

                            </p>
                            <p className='text-lg'>
                                Downpour Consultancy Services Private Limited <br></br>
                                November 2023 - Present (FullTime)<br></br>
                                Uttar Pradesh, India ( Remote)
                            </p>
                            {/* <ul className='mt-3'>
                                <li>●Analysis of requirements and implementation of them.</li>
                                <li>●Managing Front-End code and development in an efficient way.</li>
                                <li>●Develop Features following Figma.</li>
                            </ul> */}
                        </div>
                    </div>
                </motion.div>

            </div >

        </section >
    );
};

export default Experience;